import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

const AuthCallbackPage: React.FC = () => {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Supabase automatically exchanges the PKCE code when getSession() is called.
    // We just wait for the session, then redirect to the main app.
    supabase.auth.getSession().then(({ data: { session }, error }) => {
      if (error) {
        setError(error.message);
      } else if (session) {
        window.location.replace('/');
      }
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) {
        window.location.replace('/');
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  if (error) {
    return (
      <div className="loading" style={{ color: '#e74c3c' }}>
        Login failed: {error}
      </div>
    );
  }

  return <div className="loading">Authenticating...</div>;
};

export default AuthCallbackPage;
